import type { ConversationResponse } from "@9amhealth/openapi";
import { Cubit } from "blac-next";
import { globalEvents } from "src/constants/globalEvents";
import { ConversationService } from "./ConversationService";

export interface ConversationListState {
  conversations: ConversationResponse[];
  activeConversations: ConversationResponse[];
  historyConversations: ConversationResponse[];
  isDrawerOpen: boolean;
  initialLoadComplete: boolean;
}

export default class ConversationListCubit extends Cubit<ConversationListState> {
  static keepAlive = true;
  private _isMobile = false;
  private service = ConversationService.getInstance();

  constructor() {
    super({
      conversations: [],
      activeConversations: [],
      historyConversations: [],
      isDrawerOpen: false,
      initialLoadComplete: false
    });
    this.service.onConversationsChanged((conversations) => {
      this.patch({
        conversations,
        activeConversations: conversations.filter((c) => c.status === "ACTIVE"),
        historyConversations: conversations.filter(
          (c) => c.status !== "ACTIVE"
        ),
        initialLoadComplete: true
      });
    });

    this.addEventListeners();
  }

  get isMobile() {
    return this._isMobile;
  }

  set isMobile(value: boolean) {
    this._isMobile = value;
  }

  addEventListeners() {
    document.addEventListener(
      globalEvents.PUSH_NOTIFICATION_ACTION,
      this.handlePushNotificationAction
    );
  }

  private readonly handlePushNotificationAction = () => {
    void this.refresh();
  };

  refresh = async (): Promise<ConversationResponse[]> => {
    return this.service.listConversations();
  };

  toggleDrawer = (): void => {
    const opening = !this.state.isDrawerOpen;
    this.patch({ isDrawerOpen: opening });
    if (opening) {
      void this.refresh();
    }
  };

  openDrawer = (): void => {
    this.patch({ isDrawerOpen: true });
    void this.refresh();
  };

  closeDrawer = (): void => {
    this.patch({ isDrawerOpen: false });
  };

  static isEscalated(conv: ConversationResponse): boolean {
    return ConversationService.isEscalated(conv);
  }
}
